import React, { useEffect } from "react";
import Styles from "./Styles";
import { useSelector, useDispatch } from "react-redux";
import { InterviewPlannedAction } from "./../../../Redux/action/InterviewPlannedAction";
import UpdateInterview from "./UpdateInterview";
import TableHeader from "../../Common/TableHeader";
import CancelInterview from "./CancelInterview";
import { MdCancel } from "react-icons/md";

const InterviewPlanned = () => {
    const userInfo = useSelector((state) => state.InterviewPlanned.result);
    let dispatch = useDispatch();
	const { userResult } = useSelector((state) => state.Auth);
	let vendorid = userResult?.vendorid;

    useEffect(() => {
        dispatch(InterviewPlannedAction(vendorid));
    }, []);

    console.log('USERINFO--', userInfo)


    return (
        <Styles>
            <div className="">
                {/* <TableHeader heading={'Interview Planned'} /> */}
                <div className="">
                    <div className="table-responsive">
                        <table className="table-data">
                            <thead>
                                <tr>
                                    <th scope="col">Id</th>
                                    <th scope="col">Candidate Details</th>
                                    <th scope="col">Designation</th>
                                    <th scope="col">Interview Slot</th>
                                    <th scope="col">InteviewType</th>
                                    <th scope="col">Duration</th>
                                    <th scope="col">Candidate Status</th>
                                    <th scope="col">Interviewer Status</th>
                                    <th scope="col">Hiring Status</th>
                                    <th scope="col">Remark</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Rescheduled</th>
                                    <th scope="col">Cancel</th>
                                </tr>
                            </thead>
                            {userInfo.length > 0 &&<tbody>
                                {userInfo &&
                                    userInfo.map((item, i) => {
                                        return (
											<>
												<tr key={i}>
													<td>#{item.interviewId}</td>
													<td>
														{item.candidateName}
													</td>
													<td>{item.jobPosition}</td>
													<td>
														{item.interviewDate}
													</td>
													<td>{item.inteviewType}</td>
													<td>{item.duration}</td>
													{item.isAcceptedByCandidate ===
													"ACCEPTED" ? (
														<td
															style={{
																color: "green",
																fontSize:
																	"19px",
															}}
														>
															Accepted
														</td>
													) : (
														<td
															style={{
																color: "red",
															}}
														>
															Pending...
														</td>
													)}
													{item.isAcceptedByInterviewer ===
													"ACCEPTED" ? (
														<td
															style={{
																color: "green",
																fontSize:"19px",
															}}
														>
															Accepted
														</td>
													) : (
														<td
															style={{color: "red",}}
														>
															Pending...
														</td>
													)}
													<td>
														{item.candidateInterviewStatus}
													</td>
													<td>{item.remark}</td>
													{item.interviewStatus ===
													"CANCELLED" ? (
														<td
															style={{color: "red",}}
														>
															{item.interviewStatus}
														</td>
													) : (
														<td
															style={{color: "green",}}
														>
															{item.interviewStatus}
														</td>
													)}
													<td>
														<button
															className="schedule-button"
															style={{
																background:
																	"rgb(28, 101, 151)",
																    color: "white",
															    }}
														>
															<UpdateInterview
																data={item.candidateId}
																jobId={item.jobId}
																uuid={item.uuid}
																round={item.round}
															/>
														</button>
													</td>
													{item.interviewStatus ===
														"CANCELLED" ||
													item.interviewStatus ===
														"COMPLETED" ? (
														<td>
															<MdCancel
																size={35}
																color="#d3d3d3"
															/>
														</td>
													) : (
														<td>
															<CancelInterview
																data={item.interviewId}
															/>
														</td>
													)}
												</tr>
											</>
										);
                                    })}
                            </tbody>}

                        </table>
                            {userInfo.length === 0 && (
                                <div className="text-center mt-5">
                                    <h5>No Data Available</h5>
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </Styles>
    );
};

export default InterviewPlanned;
